import { render, staticRenderFns } from "./modal-resume-export.vue?vue&type=template&id=038afa0e&scoped=true&"
import script from "./modal-resume-export.vue?vue&type=script&lang=js&"
export * from "./modal-resume-export.vue?vue&type=script&lang=js&"
import style0 from "./modal-resume-export.vue?vue&type=style&index=0&id=038afa0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038afa0e",
  null
  
)

export default component.exports